import React from 'react';

import { FormControlLabel, FormGroup, FormLabel, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IconTooltip } from '../../../components/common/Tooltip/IconTooltip';
import RadioGroup from '../../../components/forms/RadioGroup';
import { ClassLevelOverrideOptions, type ClassOptionsOverrides } from '../../../types/adminConfig';
import { StyledFormControl, StyledFormControlLabel } from '../styles';


interface OverrideControlsProps {
    overrideName: keyof ClassOptionsOverrides;
    overrideValue: ClassLevelOverrideOptions;
    handleUpdateOverrides: (event: React.ChangeEvent<HTMLInputElement>) => void;
    labelText: string;
    tooltipText: string;
}

const OverrideControls: React.FC<OverrideControlsProps> = ({
    overrideName,
    overrideValue,
    handleUpdateOverrides: handleUpdateOptionsRadio,
    labelText,
    tooltipText
}) => {
    const { t } = useTranslation('admin_settings');

    return (
        <>
            <FormLabel id={`${overrideName}-label`}>{labelText}</FormLabel>
            <FormGroup>
                <RadioGroup
                    aria-labelledby={`${overrideName}-label`}
                    name={overrideName}
                    value={overrideValue}
                    onChange={handleUpdateOptionsRadio}
                >
                    <StyledFormControl>
                        <StyledFormControlLabel
                            value={ClassLevelOverrideOptions.NoOne}
                            control={<Radio aria-label={t('configuration.no-one')} />}
                            label={t('configuration.no-one')}
                        />
                        <IconTooltip>{tooltipText}</IconTooltip>
                    </StyledFormControl>
                    <FormControlLabel
                        value={ClassLevelOverrideOptions.AdminsOnly}
                        control={<Radio aria-label={t('configuration.administrators')} />}
                        label={t('configuration.administrators')}
                    />
                    <FormControlLabel
                        value={ClassLevelOverrideOptions.AdminsAndInstructors}
                        control={<Radio aria-label={t('configuration.admins-and-instructors')} />}
                        label={t('configuration.admins-and-instructors')}
                    />
                </RadioGroup>
            </FormGroup>
        </>
    );
};

export default OverrideControls;
